<template>
  <div class="insert-list-dialog">
    <modal-title title="Insert List" @close="$emit('close')" />
    <p class="text-left">Please choose the type of list you want to insert:</p>
    <div class="form-group text-left">
      <radio-button
        v-model="selectedType"
        :value="listControlTypes.CONTENT_CONTROL"
        id="list-type-control"
        name="list-type"
        label="Content Control"
        hint="Inserts a content control for each item."
      ></radio-button>
      <radio-button
        v-model="selectedType"
        :value="listControlTypes.TABLE"
        id="list-type-table"
        name="list-type"
        label="Table"
        hint="Inserts a content control with single table, whose rows will be repeated for each item."
      ></radio-button>
    </div>
    <form-buttons>
      <button type="button" class="btn btn-primary" @click="insertClicked">
        Insert
      </button>
    </form-buttons>
  </div>
</template>
<script>
import ModalTitle from "@/components/common/modal/ModalTitle.vue";
import * as listControlTypes from "@/constants/listFieldControlTypes";

const insertClicked = function() {
  const args = {
    field: this.field,
    path: this.path,
    type: this.selectedType,
  };

  this.logDebug("Inserting list.", args);
  this.$emit("insert", args);
};

export default {
  components: { ModalTitle },
  emits: ["insert", "close"],
  props: {
    field: {
      required: true,
    },
    path: {
      type: String,
      required: true,
    },
  },
  data: function() {
    return {
      selectedType: listControlTypes.CONTENT_CONTROL,
    };
  },
  computed: {
    listControlTypes: function() {
      return { ...listControlTypes };
    },
  },
  methods: {
    insertClicked,
  },
};
</script>
<style lang="scss" scoped>
.insert-list-dialog {
  text-align: left;
}
</style>
